import { state } from './state'

export const store = [
  {
    htg: 'HWT',
    companyAccountId: 'E00015',
    state: 'Johor',
    dealer: 'Eco Tyre And Service Centre',
    address: 'No.25, Jalan Sejahtera 1, Taman Nusa Damai, 81700 Pasir Gudang',
    phone: '017-7854229',
    lat: 1.49583400288254,
    lng: 103.905673984658,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/Bjf9Y2sxtjmd3C2i9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'L00105',
    state: 'Johor',
    dealer: 'L & B Tyres & Service Centre Sdn Bhd',
    address: '2, Jalan Indah 25/16, Taman Bukit Indah 2, 81200 Johor Bahru',
    phone: '018-2138588 / 07-2440996',
    lat: 1.46879477361813,
    lng: 103.651153754366,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/Ktw8bhKhCwHZL8Ac8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'O00004',
    state: 'Johor',
    dealer: 'One Tyre & Battery - Johor Jaya',
    address: '65,Jalan Keembong 49, Taman Johor Jaya,  81100 Johor Bahru',
    phone: '012-7169799 / 07-3541801',
    lat: 1.53270789887182,
    lng: 103.80744316786,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/HueStNyZ3nckBZjT8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'Q00010',
    state: 'Johor',
    dealer: 'Perkhidmatan Tayar Dan Bateri Qi Shun',
    address: '11 & 15, Jalan Beladau 5, Taman Puteri Wangsa, 81800 Ulu Tiram',
    phone: '012-7210733 / 07 - 8674131',
    lat: 1.58912476949014,
    lng: 103.804736312037,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/pSnaNys5u6MaHcq59',
  },
  {
    htg: 'HWT',
    companyAccountId: 'S00115',
    state: 'Johor',
    dealer: 'Sembilan Sembilan Tayar & Servis',
    address: '9, Jalan Baiduri, Taman Daiman Jaya,  81900 Kota Tinggi',
    phone: '019-7117100 / 07-8823100',
    lat: 1.71957690343987,
    lng: 103.888704222833,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/3VabZE4WocPuEWd89',
  },
  {
    htg: 'HWT',
    companyAccountId: 'T00184',
    state: 'Pahang',
    dealer: 'TS Smart Tyre',
    address: 'No. 2, Jalan Impian Bahagia 2/1, Taman Impian Bahagia, 26800 Kuala Rompin',
    phone: '012-9473076',
    lat: 2.80015539231514,
    lng: 103.4777755,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/uiBAacTYVuPX5FQT8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'M00047',
    state: 'Johor',
    dealer: 'Masteroda Sdn Bhd',
    address: '38, Jalan Rosmerah 2/16, Taman Johor Jaya, 81100 Johor Bahru',
    phone: '016-7570033 / 07-3627009',
    lat: 1.53596869984912,
    lng: 103.793517,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/fekfx8yRX74tp3fe9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'L00013',
    state: 'Johor',
    dealer: 'Syarikat Lim Brothers Tyres dan Bateri - Tasek',
    address: '71, Jalan Glasiar, Taman Tasek, 80200 Johor Bahru',
    phone: '017-7904463 / 07-2363207',
    lat: 1.48656830270244,
    lng: 103.7239376,
    category: 'Nexen Point',
    link: 'https://g.page/syarikat-lim-brothers-tayar-dan?share',
  },
  {
    htg: 'HWT',
    companyAccountId: 'U00024',
    state: 'Johor',
    dealer: 'Union Tyre and Service Sdn Bhd',
    address: '173, Jalan Keris 1, Taman Sri Tebrau, 80050 Johor Bahru',
    phone: '012-7843535',
    lat: 1.48966249916105,
    lng: 103.767501638632,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/1KchR1juGBQgPFiW8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'A00086',
    state: 'Penang',
    dealer: 'Auto Mechanic Service Centre Sdn Bhd',
    address: '11, Jalan Perniagaan Gemilang 2, Pusat Perniagaan Gemilang, 14000 Bukit Mertajam',
    phone: '010-5658667',
    lat: 5.35083394676983,
    lng: 100.442790637361,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/UuMwhxdeeMYVHCz49',
  },
  {
    htg: 'HWT',
    companyAccountId: 'H00091',
    state: 'Johor',
    dealer: 'Hin Hin Tayar & Bateri',
    address: '42, Jalan Bakawali 36, Taman Johor Jaya, 81100 JB',
    phone: '07-358 7371',
    lat: 1.54484899898651,
    lng: 103.793174969316,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/W2RuA4NGShRUNiZN8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'D00025',
    state: 'Johor',
    dealer: 'DS Tyre And Battery Service Centre',
    address: 'No 44, Jalan Tiram 1/6, Bandar Tiram, 81800 Ulu Tiram',
    phone: '016 - 7670807',
    lat: 1.61483668981406,
    lng: 103.8221248,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/RNQSKkJGnm4CUhbA9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'T00122',
    state: 'Johor',
    dealer: 'Top City Tyre And Car Service Centre',
    address: '500, Jalan Gangsa 10, Taman Gunung Pulai, 81000 Kulai Jaya',
    phone: '07-6615771 / 012-7425272',
    lat: 1.65660019222429,
    lng: 103.587105877265,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/6Qrykbe6Bu3ZrnEf9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'H00092 & H00028',
    state: 'Johor',
    dealer: 'HL Carcare Centre Sdn. Bhd.',
    address: '73,Jalan Indah 16/12, Taman Bukit Indah, 81200 Johor Bahru',
    phone: '016-7765993',
    lat: 1.47844190423479,
    lng: 103.665048215341,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/hR9TkrPkMz8nMDmh9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'G00003',
    state: 'Johor',
    dealer: 'Goh Brothers Tyre & Battery Services',
    address: '59, Jalan Cermai 3, Taman Mesra, Saleng, 81400 Senai',
    phone: '07-6622899 / 016-7155119',
    lat: 1.52259380440985,
    lng: 103.663448559359,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/mDH5Ga5gR5VoWGtz6',
  },
  {
    htg: 'HTP',
    companyAccountId: 'P00014',
    state: 'Kelantan',
    dealer: 'Pengkalan Kubur Tyre Auto Service Centre',
    address: 'Lot 299, Kg, Gabus Ketil, Pengkalan Kubur, Tumpat, 16080 Kota Bharu',
    phone: '013-9192800',
    lat: 6.12390372987232,
    lng: 102.251275343132,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/4pZ5S8aSdyNyqcaf9',
  },
  {
    htg: 'HTP',
    companyAccountId: 'J00004',
    state: 'Negeri Sembilan',
    dealer: 'Jam Trading Sdn Bhd',
    address: 'Lot 16373, Jalan Labu, Batu 8 Tiroi, 71900 Negeri Sembilan',
    phone: '016-9277767',
    lat: 2.74774892028863,
    lng: 101.860681760177,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/89SMXCEpLaonQyGW6',
  },
  {
    htg: 'HTP',
    companyAccountId: 'M00011',
    state: 'Terengganu',
    dealer: 'My Tyre Automotive Sdn Bhd',
    address: '36-S, Ground Floor Lorong 8, Jalan Bukit Kecil, 21100 Kuala Terengganu',
    phone: '012-3323993',
    lat: 5.31875248345927,
    lng: 103.1314209,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/acnUzbyEgqLHt3AJ8',
  },
  {
    htg: 'HTP',
    companyAccountId: 'K00006',
    state: ' Kelantan',
    dealer: 'Kedai Tayar Kubang Batang',
    address: 'Lot 1788, Kampung Kubang Batang, 16250 Tumpat',
    phone: '011-12322349',
    lat: 6.13110740963166,
    lng: 102.1772312,
    category: 'Nexen Point',
    link: 'https://g.page/kedai-tayar-kubang-batang?share',
  },
  {
    htg: 'HTP',
    companyAccountId: 'S00031',
    state: ' Pahang',
    dealer: 'SW Auto Tyres & Accessories Centre',
    address: 'GF No 17 & 18, Bandar Satelit Muadzam Shah, 26700 Muadzam Shah',
    phone: '018-2332558',
    lat: 3.06786712306454,
    lng: 103.069698130683,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/dUnyqwsDk5XtxHGg6',
  },
  {
    htg: 'HTP',
    companyAccountId: 'H00005',
    state: 'Negeri Sembilan',
    dealer: 'Hwa Xing Tayar Sdn Bhd',
    address: '382, Jalan Tan Sri Manickavasagam, 70200 Seremban',
    phone: '012-6459366',
    lat: 2.73113168796065,
    lng: 101.930401219338,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/6RxDEqijrCCP1gNq7',
  },
  {
    htg: 'HTP',
    companyAccountId: 'M00005',
    state: 'Negeri Sembilan',
    dealer: 'Pusat Tayar MK',
    address: 'No. 28, Jalan P.P. Ixora 4, Pusat Perniagaan Ixora 2, 70450 Seremban',
    phone: '016-2585889',
    lat: 2.70735183723023,
    lng: 101.9945144,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/QEQxP5byhRd5cKLT8',
  },
  {
    htg: 'HTP',
    companyAccountId: 'H00015',
    state: 'Negeri Sembilan',
    dealer: 'HF Auto Accessories & Tyre Service',
    address: 'No. 448E, Lorong Sri Pulai 2, Jalan Sikamat, 70400 Seremban',
    phone: '019-6236688',
    lat: 2.72618132732393,
    lng: 101.971053207186,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/FkoyZByE4fMEoSNv6',
  },
  {
    htg: 'HTP',
    companyAccountId: 'Q00001',
    state: 'Selangor',
    dealer: 'Quick Save Automart (M) Sdn Bhd ',
    address: '2, USJ 7/3A, UEP Subang Jaya, 47610 Subang Jaya',
    phone: '012-2020817',
    lat: 3.04818914537563,
    lng: 101.593537253974,
    category: 'Nexen Point',
    link: 'https://g.page/quicksave2u?share',
  },
  {
    htg: 'HTP',
    companyAccountId: 'V00001',
    state: 'Kuula Lumpur',
    dealer: 'VK Tyre Auto Services',
    address: '2, Jalan Pandan Indah 4/6, Pandan Indah, 55100 Kuula Lumpur',
    phone: '016-6030168',
    lat: 3.13054925390967,
    lng: 101.754533953974,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/SY9dmwSQfV6VsAyEA',
  },
  {
    htg: 'HTP',
    companyAccountId: 'T00001',
    state: 'Selangor',
    dealer: 'Tek Ming Auto Service Sdn Bhd',
    address: 'No. 1 & 3, Jalan PJS 11/24, Bandar Sunway Industrial Park, 46150 Selangor',
    phone: '016-3399288',
    lat: 3.06730187707323,
    lng: 101.602335,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/3S3ykVDCwXuYaXvz9',
  },
  {
    htg: 'HTP',
    companyAccountId: 'D00002 & D00003',
    state: 'Kuala Lumpur',
    dealer: 'Drivein Motor Sports Auto Service Centre Sdn Bhd',
    address: 'No. 150, Jalan Radin Anum Satu, Taman Sri Petaling 57000 Kuala Lumpur.',
    phone: '03-90589220',
    lat: 3.06716956160842,
    lng: 101.690526715341,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/mt5sPqYXQffHvdAn7',
  },
  {
    htg: 'HTP',
    companyAccountId: 'S00018',
    state: 'Selangor',
    dealer: 'Shah Alam Tyres & Auto Accessories Sdn Bhd',
    address: 'Lot 53, Jalan Utas 15/7, Section 15,  40000 Shah Alam',
    phone: '012-2351700',
    lat: 3.06433466992374,
    lng: 101.539573407949,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/X3e7pYMAjJcbuzr88',
  },
  {
    htg: 'HWT',
    companyAccountId: 'W00029',
    state: 'Selangor',
    dealer: 'Weng Tat Tyre Service',
    address: 'No 12, Jalan SS 14/2, 47500 Subang Jaya',
    phone: '016-3155424',
    lat: 3.072717,
    lng: 101.5916971,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/kDjyg7RLbkbShWip6',
  },
  {
    htg: 'HWT',
    companyAccountId: 'E00064',
    state: 'Perak',
    dealer: 'Pusat Servis Tayar Eng Hup Seng',
    address: 'KE2, Jalan Limau Kasturi, Taman Slim Jaya, 35800 Slim River',
    phone: '010-7620576',
    lat: 3.84174550244935,
    lng: 101.395336514779,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/YAh8eajNtxwETjLc8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'O00021',
    state: 'Selangor',
    dealer: 'Okai Pusat Servis Tayar dan Bateri',
    address: 'No. 56, Jalan Sultan Alam Shah, 42700 Banting',
    phone: '012-6913555',
    lat: 2.81036864134552,
    lng: 101.496884097187,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/nn1tnUwAMJrVKaoH9',
  },
  {
    htg: 'HWT',
    companyAccountId: 'R00037',
    state: 'Selangor',
    dealer: 'Rabbit Tyre Auto Services',
    address: 'No. 181, Jalan SS2/24, Petaling Jaya, 47300 Petaling Jaya',
    phone: '018-378 4391',
    lat: 3.11679425334329,
    lng: 101.6229728,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/zGxXn3Ww8Qv96L6y5',
  },
  {
    htg: 'HWT',
    companyAccountId: 'R00037',
    state: 'Selangor',
    dealer: 'Rabbit Tyre Auto Services',
    address: 'No. 191, Jalan SS2/24, Petaling Jaya, 47300 Petaling Jaya',
    phone: '018-378 4391',
    lat: 3.11713965555167,
    lng: 101.622753230704,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/8cqSGtSd7enMkN8b9',
  },
  {
    htg: 'HWT',
    companyAccountId: undefined,
    state: 'Perak',
    dealer: 'HUP SENG TYRE AND RIM SERVICE CENTRE',
    address: '4, persiaran halaman ampang 21, taman ipoh jaya 2, ipoh perak 31350 Ipoh',
    phone: '016-555 8023',
    lat: 4.57821329209948,
    lng: 101.136098946025,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/VjiUEkMCoK5jemSF8',
  },
  {
    htg: 'HWT',
    companyAccountId: 'A00036',
    state: 'Johor',
    dealer: 'A Teck Auto Sdn. Bhd.',
    address: '36, 36-01, 36-02, Jalan Kota 1/4, Taman Cahaya Kota Putri, 81750 Masai, Johor. ',
    phone: '016-714 9696',
    lat: 1.49281497023465,
    lng: 103.844589085891,
    category: 'Nexen Point',
    link: 'https://goo.gl/maps/tuVYDPPHiFZumKEv9',
  },
  {
    htg: 'HWT',
    companyAccountId: undefined,
    state: 'Negeri Sembilan',
    dealer: 'Brilliant Tyre & Auto Service',
    address: 'No. 1, Jalan Teratai 1, Taman Teratai, 72100 Bahau, Negeri Sembilan',
    phone: '017-206 7947',
    lat: 2.86207455796797,
    lng: 102.405463338343,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/vf5UXppBqRAJedbCA',
  },
  {
    htg: 'HTP',
    companyAccountId: 'V00001',
    state: 'Selangor',
    dealer: 'VK Tyres KL Auto Services',
    address: 'Lot 1319A, Jln 11, Kampung Baru Ampang Tambahan, 68000 Ampang, Selangor',
    phone: '016-6030168',
    lat: 3.2260923572202,
    lng: 101.739942047121,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/tXdknqtmsH24iaYi9',
  },
  {
    htg: 'HTP',
    companyAccountId: 'K00014',
    state: 'Selangor',
    dealer: 'Kaizen Autocare Sdn Bhd',
    address: '10, Jalan USJ 19/4A, Taman Perindustrian Uep, 46200 Subang Jaya, Selangor\r\n',
    phone: '016-2207208',
    lat: 3.03072788297998,
    lng: 101.588440999999,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/TMTnfcg1G399UcQ47',
  },
  {
    htg: 'HTP',
    companyAccountId: 'J00069',
    state: 'Kedah',
    dealer: 'JL Tyres Services Center',
    address: 'No 5, Taman Khaya, Jalan Pauh, 06010 Changloon.',
    phone: '016-400 9115',
    lat: 6.43672035518488,
    lng: 100.428900084655,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/uTEEQgdCb3YdJk2Q6',
  },
  {
    htg: 'HTH',
    companyAccountId: 'V00024',
    state: 'Johor',
    dealer: 'Venus Tyres Car Service Enterprise',
    address: '1, Jalan Utama 44, Mutiara Square, 81300 Skudai, Johor',
    phone: '019-664 6694',
    lat: 1.519898701,
    lng: 103.638499,
    category: 'Nexen Center',
    link: 'https://goo.gl/maps/tNaayJ44WdWuvy7L6',
  },
]
